import React from 'react';
import logo from '../images/ts.png';
import { logout } from '../redux/slices/loginSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ title, subtitle, buttonLabel, buttonAction }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-white shadow-md px-8 py-4 z-10">
      <div className="flex justify-between items-center mx-auto">
        {/* Left section with logo */}
        <div className="flex items-center space-x-3">
          <img src={logo} alt="logo" className="w-[60px]" />
        </div>

        {/* Centered title and subtitle */}
        <div className="flex-grow ml-[17%] text-center">
          <h1 className="text-2xl text-[#4B76A7] font-semibold">{title}</h1>
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>

        {/* Right section with buttons */}
        <div className="flex space-x-4">
          <button
            onClick={buttonAction}
            className="bg-gradient-to-r from-[#4B76A7] to-[#24486C] hover:opacity-90 text-white px-6 py-2 rounded-md text-sm font-medium"
          >
            {buttonLabel}
          </button>
          <button
            onClick={handleLogout}
            className="bg-red-500 hover:opacity-90 text-white px-6 py-2 rounded-md text-sm font-medium"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
